// Copyright (c) 2022 by Move Closer

import { IModal } from '@movecloser/front-core'

import { Country } from '../../../contexts'
import { DeliveryInfo } from '../../../contexts/shared/contracts/deliveryInfo'

/**
 *  @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 *  @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface IStoreService {
  /**
   * List of countries
   */
  countries: Array<Country>

  /**
   * Get delivery information for current date.
   */
  deliveryInfo: DeliveryInfo

  /**
   * Initializes (prepares) countries.
   */
  init (): Promise<void>
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const DrawerType = Symbol.for('IDrawer')

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const StoreServiceType = Symbol.for('IStoreService')

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type IDrawer = IModal
